import { ICloseButtonProps } from '../CloseButton/CloseButton';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon';
import React, { forwardRef } from 'react';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { MATERIAL_ICONS, MaterialIcon } from '../Icon/icons';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { BUTTON_MODES, CLOSE_BUTTON_VARIANTS } from '../Button/buttonVariants';
import { IconButton, IIconButtonProps } from '../IconButton/IconButton';
import { useButtonOpacityStateCss } from '../Button/ButtonRoot';

export interface ICloseButtonMiniProps extends Omit<ICloseButtonProps, 'size'> {
  name?: MaterialIcon;
}

const MINI_CLOSE_SIZE_EXEMPTION = SIZES.X_MICRO;

export const MiniCloseButtonBase = styled(IconButton)<IIconButtonProps>`
  border-radius: 50%;
  line-height: 0;

  height: ${({ theme }) => theme.sizes[MINI_CLOSE_SIZE_EXEMPTION]};
  width: ${({ theme }) => theme.sizes[MINI_CLOSE_SIZE_EXEMPTION]};
  min-height: ${({ theme }) => theme.sizes[MINI_CLOSE_SIZE_EXEMPTION]};
  min-width: ${({ theme }) => theme.sizes[MINI_CLOSE_SIZE_EXEMPTION]};

  overflow: hidden;

  ${useButtonOpacityStateCss};

  ${Icon} {
    height: ${({ theme }) => theme.sizes[MINI_CLOSE_SIZE_EXEMPTION]};
    width: ${({ theme }) => theme.sizes[MINI_CLOSE_SIZE_EXEMPTION]};
  }
`;

export const CloseButtonMini = forwardRef<HTMLButtonElement, ICloseButtonMiniProps>(({ name = MATERIAL_ICONS.Cancel, variant, ...rest }, ref) => {
  const { generateTestId } = useTestId(rest, 'CloseButtonMini');

  return (
    <MiniCloseButtonBase mode={BUTTON_MODES.MINIMAL} icon={name} ref={ref} variant={variant ?? CLOSE_BUTTON_VARIANTS.BLACK50} {...generateTestId()} {...rest} />
  );
});
